import { seedComplimentaryCommunityRuns } from "utils/payment/api";

/**
 * Server-side ensure: complimentary seed (eligible owners), legacy capacity normalize,
 * and runHistory usage accounting. Idempotent.
 *
 * @returns {Promise<{ availableRuns, runsUsed, runsRemaining, seeded, eligible } | null>}
 */
export const ensureCommunityRunCapacityOnServer = async (communityId) => {
    if (!communityId) {
        return null;
    }

    try {
        const response = await seedComplimentaryCommunityRuns({ communityId });

        if (response?.isAxiosError) {
            console.log(
                "Community run capacity ensure failed",
                response?.response?.data || response?.message || response
            );
            return null;
        }

        return response?.data ?? null;
    } catch (error) {
        console.log("Community run capacity ensure failed", error?.message || error);
        return null;
    }
};

/** Merge API capacity fields into communityDetails for immediate UI (Firestore is source of truth). */
export const mergeRunCapacityIntoCommunityDetails = (communityDetails = {}, capacityResult) => {
    if (!capacityResult || capacityResult.availableRuns == null) {
        return communityDetails;
    }

    return {
        ...communityDetails,
        availableRuns: capacityResult.availableRuns,
    };
};
